import React, { useState, useRef, useEffect } from 'react';
import './News.css';
import Header from '../components/Header';
import Footer from '../components/Footer';

// --- Data ---

const NEWS_ITEMS = [
  {
    id: 1,
    title: 'Devnar Students Shine at National Science Congress',
    date: 'December 2023',
    category: 'Achievement',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/06/image29.jpg',
    excerpt: 'Out of 638 projects from across Asia, Devnar School project was chosen as one of the top 11 projects at the 30th National Children\'s Science Congress.',
    featured: true
  },
  {
    id: 2,
    title: 'President Kovind Presents National Award',
    date: 'December 2017',
    category: 'Recognition',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/06/image22.jpg',
    excerpt: 'Dr. Saibaba Goud receives National Award from President Ram Nath Kovind on World Disabled Day at Vigyan Bhavan, New Delhi.',
    featured: true
  },
  {
    id: 3,
    title: 'PM Modi Releases Braille Biography of Sardar Patel',
    date: 'July 2014',
    category: 'Recognition',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/06/image18-768x1080.jpg',
    excerpt: 'Prime Minister Narendra Modi released the Braille version of the Biography of Sardar Vallabhbhai Patel developed by Dr. Saibaba Goud.',
    featured: true
  },
  {
    id: 4,
    title: 'Devnar Foundation Honoured as Best NGO in Telangana',
    date: '2016',
    category: 'Award',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/06/image25-768x526.jpg',
    excerpt: 'Honoured by Shri K. Chandrashekar Rao, Honorable Chief Minister, Telangana as the best NGO in the state.',
  },
  {
    id: 5,
    title: 'First Visually Challenged CA Graduate from Devnar',
    date: '2015',
    category: 'Achievement',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/06/image19-768x535.jpg',
    excerpt: 'Student Rajasekhar Reddy successfully passed the CA exams, a historic first for a visually challenged person in the country.',
  },
  {
    id: 6,
    title: 'Devnar Students Represent India in International Cricket',
    date: '2013',
    category: 'Sports',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/06/image26-768x765.jpg',
    excerpt: 'Two visually challenged students selected to represent the Indian Cricket Team for the Blind in a one-day International against England.',
  },
  {
    id: 7,
    title: 'EVM Modification Enables Independent Voting',
    date: '2004',
    category: 'Innovation',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/06/image8.jpg',
    excerpt: 'Dr. Saibaba Goud modified the Electronic Voting Machine enabling visually challenged to exercise their franchise without assistance.',
  },
  {
    id: 8,
    title: 'Wings of Fire Released in Braille',
    date: '2004',
    category: 'Recognition',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/06/image4.jpg',
    excerpt: 'President Dr. A.P.J. Abdul Kalam released the Braille version of his autobiography "Wings of Fire" at Raj Bhavan.',
  },
  {
    id: 9,
    title: 'Limca Book of Records for Bhagavad Gita in Braille',
    date: '2004',
    category: 'Achievement',
    image: 'https://devnarfoundationfortheblind.org/wp-content/uploads/2022/06/image5-768x849.jpg',
    excerpt: 'Dr. Goud and Mrs. Jyothi Goud entered the Limca Book of World Records for translating Srimad Bhagavad Gita into Telugu Braille.',
  },
];

const CATEGORIES = [
  { id: 'all', label: 'All News' },
  { id: 'Achievement', label: 'Achievements' },
  { id: 'Recognition', label: 'Recognition' },
  { id: 'Award', label: 'Awards' },
  { id: 'Sports', label: 'Sports' },
  { id: 'Innovation', label: 'Innovation' },
];

// --- Reusable Components ---

function Reveal({ as: Tag = 'div', className = '', delay = 0, children, ...rest }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setVisible(true); obs.disconnect(); } },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [ref]);
  return (
    <Tag
      ref={ref}
      className={`reveal ${visible ? 'reveal-visible' : ''} ${className}`}
      style={{ transitionDelay: visible ? `${delay}ms` : '0ms' }}
      {...rest}
    >
      {children}
    </Tag>
  );
}

// --- Main News Component ---

export default function News() {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  const filteredNews = NEWS_ITEMS.filter(item => {
    const matchesCategory = selectedCategory === 'all' || item.category === selectedCategory;
    const matchesSearch = item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         item.excerpt.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const featuredNews = NEWS_ITEMS.filter(item => item.featured);
  const regularNews = filteredNews.filter(item => !item.featured);

  return (
    <>
      <Header />
      <div className="news-page devnar">
        <a className="skip-link" href="#main-news">Skip to main content</a>

        {/* --- Page Hero --- */}
        <section className="page-hero-news">
          <div className="hero-background">
            <div className="hero-overlay"></div>
            <div className="hero-pattern"></div>
          </div>
          <div className="wrap hero-content-news">
            <Reveal>
              <span className="hero-badge">Media</span>
              <h1>News & Media</h1>
              <p className="hero-subtitle">
                Recent updates, press mentions, and milestones from Devnar Foundation.
              </p>
            </Reveal>
          </div>
        </section>

        <main id="main-news" className="wrap page-content-news">

          {/* --- News Stats --- */}
          <section className="news-stats">
            <div className="stats-grid">
              <div className="stat-card">
                <span className="stat-number">{NEWS_ITEMS.length}+</span>
                <span className="stat-label">News Stories</span>
              </div>
              <div className="stat-card">
                <span className="stat-number">36+</span>
                <span className="stat-label">Years of Coverage</span>
              </div>
              <div className="stat-card">
                <span className="stat-number">6</span>
                <span className="stat-label">Presidential Honours</span>
              </div>
            </div>
          </section>

          {/* --- Featured News --- */}
          {featuredNews.length > 0 && (
            <section className="featured-news">
              <Reveal className="section-title" as="div">
                <span className="eyebrow">Featured</span>
                <h2>Top Stories</h2>
                <div className="rule" />
              </Reveal>

              <div className="featured-grid">
                {featuredNews.map((item, index) => (
                  <Reveal 
                    key={item.id} 
                    className={`featured-card ${index === 0 ? 'featured-main' : ''}`}
                    delay={index * 100}
                  >
                    <div className="featured-image">
                      <img src={item.image} alt={item.title} loading="lazy" />
                      <span className="featured-category">{item.category}</span>
                    </div>
                    <div className="featured-content">
                      <span className="featured-date">{item.date}</span>
                      <h3>{item.title}</h3>
                      <p>{item.excerpt}</p>
                      <a href="#" className="read-more">Read Full Story →</a>
                    </div>
                  </Reveal>
                ))}
              </div>
            </section>
          )}

          {/* --- Search & Filter --- */}
          <section className="news-filter-section">
            <div className="filter-search-wrapper">
              <div className="filter-buttons">
                {CATEGORIES.map((category) => (
                  <button
                    key={category.id}
                    className={`filter-btn ${selectedCategory === category.id ? 'active' : ''}`}
                    onClick={() => setSelectedCategory(category.id)}
                  >
                    {category.label}
                  </button>
                ))}
              </div>
              <div className="search-box">
                <input
                  type="text"
                  placeholder="Search news..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="search-input"
                />
                <span className="search-icon">🔍</span>
              </div>
            </div>
          </section>

          {/* --- News Grid --- */}
          <section className="news-grid-section">
            {filteredNews.length === 0 ? (
              <div className="no-results">
                <span className="no-results-icon">📰</span>
                <h3>No News Found</h3>
                <p>Try adjusting your search or filter criteria.</p>
              </div>
            ) : (
              <div className="news-grid">
                {regularNews.map((item, index) => (
                  <Reveal 
                    key={item.id} 
                    className="news-card" 
                    delay={(index % 9) * 60}
                  >
                    <div className="news-card-image">
                      <img src={item.image} alt={item.title} loading="lazy" />
                      <span className="news-card-category">{item.category}</span>
                    </div>
                    <div className="news-card-content">
                      <span className="news-card-date">{item.date}</span>
                      <h3>{item.title}</h3>
                      <p>{item.excerpt}</p>
                      <a href="#" className="read-more">Read More →</a>
                    </div>
                  </Reveal>
                ))}
              </div>
            )}
          </section>

          {/* --- CTA Section --- */}
          <Reveal as="section" className="cta-band-news">
            <div className="cta-content">
              <span className="cta-eyebrow">Stay Connected</span>
              <h2>Follow Our Journey</h2>
              <p>
                Stay updated with the latest news, achievements, and milestones from 
                Devnar Foundation. Be a part of our story.
              </p>
              <div className="cta-buttons">
                <a className="btn btn-primary" href="gallery.html">View Gallery</a>
                <a className="btn btn-outline btn-outline-light" href="contacts.html">Contact Us</a>
              </div>
            </div>
          </Reveal>

        </main>
      </div>
      <Footer />
    </>
  );
}